import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchMemberEmail = createAsyncThunk(
  'users/memberEmail/fetch',
  async ({ memberId }, { extra: { gccApiClient } }) => {
    const { memberEmail: email } = await gccApiClient.getMemberPromoEmail(memberId);
    return { memberId, email };
  },
);
